import React from 'react';
import { router } from '../lib/router';

interface LinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Custom Link component for client-side navigation
 * Uses history-based path URLs for crawlable links.
 */
export default function Link({ to, children, className = '', style }: LinkProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    
    // Use our router for client-side navigation
    router.navigate(to);
  };

  // Visible href should be a clean path (no hash)
  const href = to.startsWith('/') ? to : `/${to.replace(/^#/, '')}`;
  
  return (
    <a href={href} onClick={handleClick} className={className} style={style}>
      {children}
    </a>
  );
}
